import { useCentralizedMe } from '@crehana/auth';

import { useForcedUi } from '@/shared/hooks/use-forced-ui';

import {
  isKnownForcedMyRequestsVariant,
  removeForcedMyRequest,
} from '../use-my-requests/forced-my-requests';
import { useTimeAndAttendanceUserOvertimeRequestCancelMutation } from './cancel-overtime-request.v5.generated';

// No payload carries a `success` field (api-contract-verified.md). The success branch
// resolves only `overtime_request` — the boolean the caller needs comes from `__typename`.
export const useCancelOvertimeRequest = () => {
  const { currentPageOrganization } = useCentralizedMe();
  const orgId = currentPageOrganization?.id ?? 0;

  // QA/demo override, off unless `?force=solicitudes[:variant]` is in the
  // URL. A forced row has no real id, so cancelling it must never reach
  // `cancel_overtime_request` — it only drops out of the local fixture.
  const forced = isKnownForcedMyRequestsVariant(useForcedUi('solicitudes'));

  const [cancelMutation, { loading: cancelling }] =
    useTimeAndAttendanceUserOvertimeRequestCancelMutation();

  const cancelRequest = async (overtimeRequestId: string): Promise<boolean> => {
    if (forced) {
      removeForcedMyRequest(overtimeRequestId);
      return true;
    }

    const { data } = await cancelMutation({
      variables: {
        input: {
          centralized_organization_id: orgId,
          overtime_request_id: overtimeRequestId,
        },
      },
      context: { clientName: 'v5' },
    });
    const result = data?.time.overtime_requests.cancel_overtime_request;
    return result?.__typename === 'TimeCancelOvertimeRequestPayload';
  };

  return { cancelRequest, cancelling };
};
